import {
  Routes,
  Route,
  useLocation,
  matchPath,
  Outlet,
  Navigate,
  useNavigate,
} from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import routesConfig from "./routesConfig";
import { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { Spin } from "antd";
import { base_url } from "../utils/apiConfig";
import axios from "axios";
import FooterLayout from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";

const AppWithRouter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentRoute = routesConfig.find((route) => matchPath(route.path, location.pathname));
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    let encryptedToken = urlParams.get("token");

    const handleTokenFlow = async () => {
      const insightCode = urlParams.get("insight_code");
      if (insightCode) {
        try {
          const response = await axios.post(
            `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/insight_login`,
            { code: insightCode }
          );
          const token = response.data.token;
          const user = await axios.get(
            `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/user`,
            { headers: { Authorization: `Token ${token}` } }
          );
          localStorage.setItem("authToken", token);
          localStorage.setItem("userDetails", JSON.stringify(user.data));
          localStorage.setItem("userEmailDetails", JSON.stringify(user.data.client));
          localStorage.setItem("activeTab", "dashboard");
          localStorage.setItem("activeMainTab", "dashboard");

          window.location.replace("/dashboard");
          return;
        } catch (error) {
          console.log("Client Insight link expired:", error);
          localStorage.removeItem("authToken");
          navigate("/login", { replace: true });
        }
      }
      if (encryptedToken) {
        try {
          encryptedToken = decodeURIComponent(encryptedToken).trim();
          const secretKey =
            "e9w9r3q1w7d4f7t1g6c0s7v6c1x7z3b8m1y9e6a4q7e5t0r6n0l1p3u8a4z0c1!@#";
          const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
          const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

          if (decryptedToken) {
            localStorage.setItem("authToken", decryptedToken);
            await fetchUserDetails(decryptedToken);
          }
        } catch (error) {
          console.log("Error decrypting token:", error);
        }
      }

      // Even if there's no token, stop showing the loader
      setLoading(false);
    };

    handleTokenFlow();
  }, [location]);

  
  const fetchUserDetails = async (token) => {
    try {
      const getApiUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/user`;
      const response = await axios.get(getApiUrl, {
        headers: { Authorization: `Token ${token}` },
      });

      if (response.data) {
        localStorage.setItem("userDetails", JSON.stringify(response.data));
        localStorage.setItem(
          "userEmailDetails",
          JSON.stringify(response.data.client)
        );
        navigate("/dashboard", { replace: true });
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };
  if (loading) {
    return (
      <div className="app-route-container">
        <div className="app-route-content">
          <Spin fullscreen size="large" />
        </div>
        <div className="no-print">
          <FooterLayout />
        </div>
      </div>
    );
  }
  if (location.pathname === "/login" && token) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <div className="app-route-container">
        <div className="app-route-content">
          {currentRoute?.navbarVisible && (
            <div className="navbar-slot no-print">
              <Navbar />
            </div>
          )}
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route element={<Outlet />}>
              {routesConfig.map(({ path, element, navbarVisible }, index) => (
                <Route
                  key={index}
                  path={path}
                  element={
                    <ProtectedRoute path={path}>
                      {navbarVisible ? (
                        <ProtectedRoute>{element}</ProtectedRoute>
                      ) : (
                        element
                      )}
                    </ProtectedRoute>
                  }
                />
              ))}
            </Route>
          </Routes>
        </div>
        <div className="no-print" style={{ padding: 0 }}>
          <FooterLayout />
        </div>
      </div>
    </>
  );
};

export default AppWithRouter;
